import { useAuth0 } from '@auth0/auth0-react';

const AuthGate = ({ children }) => {
  const { isAuthenticated, isLoading, user, loginWithRedirect, logout, error } = useAuth0();

  if (isLoading) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="header-text">Checking your access…</div>
          </div>
        </div>
      </div>
    );
  }

  if (isAuthenticated && user) {
    const handleLogout = () => logout({ logoutParams: { returnTo: window.location.origin } });

    if (typeof children === 'function') {
      return children({ user, logout: handleLogout });
    }
    return children;
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="header-text">
            <h1>Sign in to continue</h1>
            <p>Access is restricted to authorized accounts.</p>
            {error && <div className="alert alert-danger">{error.message}</div>}
            <button
              className="btn btn-success"
              type="button"
              onClick={() => loginWithRedirect()}
            >
              Sign in
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthGate;
